import React from 'react';

import { connect, useDispatch } from 'react-redux';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

import AppState from '@webapp/store/state';
import { ProductSample } from '@webapp/store/merch/state';
import { ValidateMerchProductSample } from '@webapp/store/merch/action-creators';

import { MerchCatalogItemColor } from '@services/merch/types/api/merch-catalog-item';

import { DropdownCtrl } from '@webapp/controllers/form/dropdown';

import ProductColor from './product-color';

import Box from '@components/layout/box';
import Grid from '@components/basics/grid';
import BoxTitleHeader from '@components/layout/box-title-header';
interface MerchProductColorSizeProps {
  className?: string;
}

interface ProductColorSizeStateProps {
  productSize?: string;
  products?: MerchCatalogItemColor[];
  productSample?: ProductSample | null;
  productSizesAvailable: {
    label: string;
    value: string;
  }[];
  hasItemBelow?: boolean;
}

const mapStateToProps = (state: AppState) => {
  const productSizesAvailable = state.merch.active?.colorSize?.sizes || [];
  const productSize = state.merch.active?.productSample?.productSize;
  const products = state.merch.active?.colorSize?.colors || [];
  const productSample = state?.merch?.active?.productSample;
  return {
    productSize,
    products,
    productSample,
    productSizesAvailable: productSizesAvailable.map((size) => {
      return { label: size.label, value: size.label };
    }),
  };
};

const ReceiveSampleProduct = ({
  products,
  productSize,
  productSample,
  productSizesAvailable,
  hasItemBelow,
}: MerchProductColorSizeProps & ProductColorSizeStateProps) => {
  const dispatch = useDispatch();

  const updateReceiveSampleOrder = (size: string) => {
    dispatch(
      new ValidateMerchProductSample({ ...productSample, productSize: size })
    );
  };
  return (
    <Grid gap={3}>
      <Box noBorderTop noBorderBottom>
        <BoxTitleHeader
          className="mb-20"
          title={<Translate id="MERCH.PRODUCT_SAMPLE.COLOR.TITLE" />}
          text={<Translate id="MERCH.PRODUCT_SAMPLE.COLOR.TEXT" />}
        />
        <ProductColor products={products} />
      </Box>
      <Box noBorderTop noBorderBottom={hasItemBelow}>
        <BoxTitleHeader
          className="mb-20"
          title={<Translate id="MERCH.PRODUCT_SAMPLE.SIZE.TITLE" />}
          text={<Translate id="MERCH.PRODUCT_SAMPLE.SIZE.TEXT" />}
        />
        <DropdownCtrlContainer>
          <DropdownCtrl
            options={productSizesAvailable}
            value={productSize}
            title={<Translate id="MERCH.PRODUCT_SAMPLE.SIZE.DROPDOWN" />}
            parentRelative
            onChange={updateReceiveSampleOrder}
          />
        </DropdownCtrlContainer>
      </Box>
    </Grid>
  );
};

const DropdownCtrlContainer = styled.div`
  position: relative;
`;
export default connect(mapStateToProps)(ReceiveSampleProduct);
